import $ from "jquery";
import moment from "moment";
import React, { Component } from "react";
import Datetime from "react-datetime";
import "react-datetime/css/react-datetime.css";
import { Redirect } from "react-router-dom";
import Comm from "../comm/comm";
import Context from "../context/context";
import Translation from "../translation/translation";

class ManualResort extends Component {
    ResortData = null;
    CurrentOperator = null;
    CurrentSorter = null;
    CurrentInA = null;
    OnDate = null;

    constructor(props) {
        super(props);
        if (!Comm.ValidSession()) return;

        var sid = Context.GetContext().Sid;
        this.ResortData = Comm.GetManualSortingData({ session: sid });
        if (this.ResortData.length == 0) {
            this.state = {
                NoData: true,
            };
        } else {
            this.CurrentOperator = this.ResortData[0];

            this.CurrentSorter = this.CurrentOperator.sorters[0];
            this.CurrentInA = this.CurrentSorter.articles_in[0];

            this.state = {
                Operators: this.ResortData,
                Sorters: this.ResortData[0].sorters,
                InputArticles: this.ResortData[0].sorters[0].articles_in,
                OutputArticles: this.ResortData[0].sorters[0].articles_in[0].articles_out,
            };

            this.ChangeDate = this.ChangeDate.bind(this);
            this.ChangeOperator = this.ChangeOperator.bind(this);
            this.ChangeSorter = this.ChangeSorter.bind(this);
            this.ChangeInputArticle = this.ChangeInputArticle.bind(this);

            this.Save = this.Save.bind(this);
        }

        //this.Save = this.Save.bind(this);
    }

    ChangeOperator() {
        var oid = $("#ddlOperator").val();
        for (var o of this.ResortData)
            if (o.id == oid) {
                this.CurrentOperator = o;
                this.CurrentSorter = this.CurrentOperator.sorters[0];
                this.CurrentInA = this.CurrentSorter.articles_in[0];
                break;
            }

        this.setState({
            Sorters: this.CurrentOperator.sorters,
            InputArticles: this.CurrentOperator.sorters[0].articles_in,
            OutputArticles: this.CurrentOperator.sorters[0].articles_in[0].articles_out,
        });
    }

    ChangeSorter() {
        var sid = $("#ddlSorter").val();
        for (var o of this.CurrentOperator.sorters)
            if (o.id == sid) {
                this.CurrentSorter = o;
                this.CurrentInA = this.CurrentSorter.articles_in[0];
                break;
            }

        this.setState({
            InputArticles: this.CurrentSorter.articles_in,
            OutputArticles: this.CurrentSorter.articles_in[0].articles_out,
        });
    }

    ChangeInputArticle() {
        var iid = $("#ddlInputArticle").val();
        for (var o of this.CurrentSorter.articles_in)
            if (o.id == iid) {
                this.CurrentInA = o;
                break;
            }

        this.setState({
            OutputArticles: this.CurrentInA.articles_out,
        });
    }

    ChangeDate(date) {
        this.setState({
            Date: date,
        });
    }

    Save() {
        if ($("#tbQuantity").val() == "") return;
        var sid = Context.GetContext().Sid;
        var data = {
            session: sid,
            operator: this.CurrentOperator.id,
            article_in: this.CurrentInA.id,
            article_out: parseInt($("#ddlOutputArticles").val(), 10),
            sorter: this.CurrentSorter.id,
            qty: parseFloat($("#tbQuantity").val()),
        };

        if (this.state.Date != null) data.date = moment(this.state.Date).format("YYYYMMDD");

        $("#tbQuantity").val("0");
        Comm.SaveManualSort(data);
    }

    render() {
        if (!Comm.ValidSession()) {
            Context.Logout();
            return <Redirect to="/login" push></Redirect>;
        }
        if (Context.RenderNotOK(this.props.history)) return null;

        return this.state.NoData ? (
            <div>Enter sorter data</div>
        ) : Context.HasRight("rmanualresort") === true ? (
            <div className="panel panel-default">
                <div className="panel-heading">{Translation.Trans("manualresort")}</div>
                <div className="panel-body">
                    <div className="row">
                        <div className="col-md-6">
                            <label for="ddlOperator">{Translation.Trans("operator")}</label>
                            <select id="ddlOperator" className="form-control" onChange={this.ChangeOperator}>
                                {this.state.Operators.map((item) => (
                                    <option value={item.id}>{item.name}</option>
                                ))}
                            </select>
                        </div>
                        <div className="col-md-6">
                            <label for="ddlSorter">{Translation.Trans("sorter")}</label>
                            <select id="ddlSorter" className="form-control" onChange={this.ChangeSorter}>
                                {this.state.Sorters.map((item) => (
                                    <option value={item.id}>{item.name}</option>
                                ))}
                            </select>
                        </div>
                    </div>
                    <div className="row">
                        <div className="col-md-6">
                            <label for="ddlInputArticle">{Translation.Trans("inputarticles")}</label>
                            <select
                                id="ddlInputArticle"
                                className="form-control"
                                onChange={this.ChangeInputArticle}
                            >
                                {this.state.InputArticles.map((item) => (
                                    <option value={item.id}>{item.name}</option>
                                ))}
                            </select>
                        </div>
                        <div className="col-md-6">
                            <label for="ddlOutputArticles">{Translation.Trans("outputarticles")}</label>
                            <select id="ddlOutputArticles" className="form-control">
                                {this.state.OutputArticles.map((item) => (
                                    <option value={item.id}>{item.name}</option>
                                ))}
                            </select>
                        </div>
                    </div>
                    <div className="row">
                        <div className="col-md-6">
                            <label for="tbQuantity">{Translation.Trans("quantity")}</label>
                            <input type="number" id="tbQuantity" className="form-control" defaultValue="0" />
                        </div>

                        <div className="col-md-6">
                            <label for="dpDate">{Translation.Trans("date")}</label>
                            <Datetime
                                inputProps={{
                                    placeholder: "N/A",
                                    readOnly: "true",
                                    className: "form-control pointhand",
                                }}
                                dateFormat="DD.MM.YYYY"
                                timeFormat="HH:mm:ss"
                                onChange={this.ChangeDate}
                                value={this.state.Date}
                                closeOnSelect="true"
                            ></Datetime>
                        </div>
                    </div>
                    <div className="row">
                        <div className="col-md-6">
                            {Context.HasRight("rmanualresort") === true ? (
                                <button className="btn btn-primary pull-right" onClick={this.Save}>
                                    {Translation.Trans("save")}
                                </button>
                            ) : null}
                        </div>
                    </div>
                </div>
            </div>
        ) : (
            <div>{Translation.Trans("noRights")}</div>
        );
    }
}

export default ManualResort;



// WEBPACK FOOTER //
// ./src/pages/manualresort.js